/* eslint-disable import/no-cycle */
import { takeLatest, put } from 'redux-saga/effects'
import { Types } from '../ducks/tasks'
import { graphClient } from './auth'
import { notifyError } from '../../utils/notify'

function* getAllMyPlannerTasks() {
  try {
    const endpoint = 'me/planner/tasks?top=10000'

    const res = yield graphClient.api(endpoint).get()

    console.tron.log('getAllMyPlannerTasks res', res)

    yield put({
      type: Types.GET_ALL_MY_PLANNER_TASKS_SUCCEEDED,
      payload: res.value,
    })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível carregar as suas tarefas.')
    yield put({
      type: Types.GET_ALL_MY_PLANNER_TASKS_FAILED,
    })
  }
}

export const tasksSagas = [
  takeLatest(Types.GET_ALL_MY_PLANNER_TASKS_REQUESTED, getAllMyPlannerTasks),
]
